import { Entry } from '../Entry'

export function Entry20220223() {
  return (
    <Entry title="23/02/2022 - v3.0.0-beta-16">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12412/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
